/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'classnames';
import { CheckOutlined } from '@ant-design/icons';
import classes from './FilterDropdown.module.scss';

const FilterDropdownChoosing = ({ multiple = false, checks, setChecks, items }) => {
  const tItems = items || [];
  const tChecks = checks || [];
  return (
    <div className={classes.filterDropdownChoosing}>
      <ul>
        {tItems.map(item => {
          const isActive = tChecks.includes(item.value);
          return (
            <li key={item.id} className={cn({
              [classes.isActive]: isActive
            })}>
              {isActive && (<CheckOutlined />)}
              <span onClick={() => {
                if (multiple) {
                  setChecks(isActive ? tChecks.filter(v => v !== item.value) : [...tChecks, item.value])
                } else {
                  setChecks(isActive ? [] : [item.value])
                }
              }} className={classes.label}>{item.label}</span>
          </li>
          );
        })}
      </ul>
    </div>
  );
}

export default FilterDropdownChoosing;